<ion-content style="--padding-top: 56px;">
    <div *ngIf="serverCreating" style="position:fixed;width: 100%;padding: 16px;background-color: rgb(131, 131, 255);text-align: center; z-index: 1000000000; display: flex; align-items: center;justify-content: center;">
        Creating server {{serverCreating.name}}, please wait 5 to 8 minutes...
        <ion-spinner style="margin-left: 20px;width: 18px;padding-top: 20px;"></ion-spinner>
    </div>
    <div *ngIf="loading"
        style="position:fixed;width: 100%;height: 100%;background-color: rgba(240, 248, 255, 0.685);display: flex;justify-content: center;align-items: center;z-index: 100000;">
        <ion-spinner></ion-spinner>
    </div>
    
    <div class="instances">
        <div style="font-size: 30px;font-weight: bold;margin-bottom: 15px; margin-top: 16px;">{{ 'ALL_YOUR_TOTALUM_PROJECTS' | translate }}</div>

        <div class="b-instances-list">
            <div class="instances-list-header">
                <div class="instances-list-header-title">{{ 'FREE_PROJECTS' | translate }}</div>
                <div class="instances-list-header-button">
                    <ion-button class="button-primary" (click)="openCreateInstanceModal({plan:'free'})" mode="ios">{{"CREATE_FREE_PROJECT" | translate}}</ion-button>
                </div>
            </div>
            
            <div class="instances-list-content">
                
                <ng-container *ngIf="!freeInstances || freeInstances?.length === 0">
                    <span>
                        You don't have any free Totalum projects created yet, click on "Create new" to start.
                    </span>
                </ng-container>

                <div class="instances-list-content-instances" *ngIf="freeInstances && freeInstances.length > 0">
                    <app-instance-box   *ngFor="let instance of freeInstances"
                    (onOpenInstance)="openTotalumInstance(instance)" [instance]="instance"
                    (onInteractInstance)="onInteractInstance($event, instance)"></app-instance-box>
                </div>
            </div>
        </div>

        <div style="position: relative;">

            <div class="no-pay-overlay" *ngIf="(userData && !userData?.stripeClientId)">
                <div> For continue to a higher plan you need to enter a valid card</div>
                <br>
                <ion-button (click)="goToBilling()" class="button-success" mode="ios">Add Payment Method</ion-button>
            </div>
        <div  [ngStyle]="(userData && !userData?.stripeClientId) ? {'filter': 'blur(3px)', 'pointer-events': 'none', 'user-select': 'none'} : {}">
            
        <div class="b-instances-list">
            <div class="instances-list-header">
                <div class="instances-list-header-title">{{ 'BASIC_PROJECTS' | translate }}</div>
                <div class="instances-list-header-button">
                    <ion-button class="button-primary" (click)="openCreateInstanceModal({plan:'shared'})" mode="ios">{{ 'CREATE_BASIC_PROJECT' | translate }}</ion-button>
                </div>
            </div>

            
            <div class="instances-list-content">
                <ng-container *ngIf="!sharedInstances || sharedInstances?.length === 0">
                    <span>
                        You don't have any shared instances yet, click on "Create new" to start.
                    </span>
                </ng-container>

                <div class="instances-list-content-instances" *ngIf="sharedInstances && sharedInstances.length > 0">
                    <app-instance-box   *ngFor="let instance of sharedInstances"
                    (onOpenInstance)="openTotalumInstance(instance)" [instance]="instance"
                    (onInteractInstance)="onInteractInstance($event,instance)"></app-instance-box>
                </div>
            </div>
        </div>

        <div class="b-instances-list">
            <div class="instances-list-header">
                <div class="instances-list-header-title"> {{ 'PROFESSIONAL_PROJECTS' | translate }}</div>
                <div class="instances-list-header-button">
                    <ion-button class="button-primary" (click)="openCreateInstanceModal({plan:'profesional'})" mode="ios">{{ 'CREATE_PROFESSIONAL_PROJECT' | translate }}</ion-button>
                </div>
            </div>

            
            <div class="instances-list-content">
                <ng-container *ngIf="!profesionalInstances || profesionalInstances?.length === 0">
                    <span>
                        {{ 'NO_PROFESSIONAL_INSTANCES_YET_CLICK_TO_CREATE' | translate }}
                    </span>
                </ng-container>

                <div class="instances-list-content-instances" *ngIf="profesionalInstances && profesionalInstances.length > 0">
                    <app-instance-box   *ngFor="let instance of profesionalInstances"
                    (onOpenInstance)="openTotalumInstance(instance)" [instance]="instance"
                    (onInteractInstance)="onInteractInstance($event,instance)"></app-instance-box>
                </div>
            </div>
        </div>

        <div class="b-instances-list">
            <div class="instances-list-header">
                <div class="instances-list-header-title">{{ 'DEDICATED_SERVERS' | translate }}</div>
                <div class="instances-list-header-button">
                    <ion-button class="button-tertiary" (click)="openCreateServerModal()" mode="ios">{{ 'CREATE_SERVER' | translate }}</ion-button>
                </div>
            </div>

            <div class="instances-list-content">
                <ng-container *ngIf="!servers || servers?.length === 0">
                    <span>
                        {{ 'YOU_HAVE_NO_DEDICATED_SERVERS_YET_CLICK_TO_CREATE' | translate }}
                    </span>
                </ng-container>

                <div class="server" *ngFor="let server of servers">
                    <div class="instances-list-header">
                        <div class="instances-list-header-title">{{ 'SERVER' | translate }} {{server?.name}}</div>
                        <div class="instances-list-header-button">
                            <ion-button (click)="openCreateInstanceModal({serverName: server?.name})" class="button-primary"  mode="ios">{{ 'CREATE_PROJECT_IN_THIS_SERVER' | translate }}</ion-button>
                            <ion-button mode="ios" class="button-secondary" (click)="onShowServerPopoverMenu($event, server)">
                                <ion-icon slot="start" name="create-outline"></ion-icon>
                                
                                {{ 'EDIT' | translate }}
                            </ion-button>
                        </div>
                    </div>
                    <div class="server-content">
                        <ng-container *ngIf="!server?.totalumInstancesPupulated || server.totalumInstancesPupulated?.length === 0">
                            <span>
                                {{ 'NO_INSTANCES_IN_SERVER_CLICK_TO_CREATE_FOR_START' | translate }}
                            </span>
                        </ng-container>

                        <ng-container *ngIf="$any(server?.totalumInstancesPupulated)?.length > 0">
                            <app-instance-box *ngFor="let instance of server?.totalumInstancesPupulated"
                            (onOpenInstance)="openTotalumInstance(instance)"
                            (onInteractInstance)="onInteractInstance($event, instance, server.name)"
                            [instance]="instance"
                            
                            ></app-instance-box>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

    </div>
    </div>
        <br><br><br><br><br>

    </div>
</ion-content>